export function convert24hrTo12HrFormat(time) {
    let convertedTime;
    // Check correct time format and split into components
    convertedTime = time.match(/^([01]\d|2[0-3])(:)([0-5]\d)(:[0-5]\d)?$/) || [
        time,
    ];
    if (convertedTime.length > 1) {
        // If time format correct
        convertedTime = convertedTime.slice(1); // Remove full string match value
        convertedTime[5] = +convertedTime[0] < 12 ? ' AM' : ' PM'; // Set AM/PM
        convertedTime[0] = +convertedTime[0] % 12 || 12; // Adjust hours
    }
    return convertedTime.join(''); // return adjusted time or original string
}
export function convert12hrTo24HrFormat(s) {
    //format must be in 09:00 AM
    const ampm = s.slice(-2);
    const hours = Number(s.slice(0, 2));
    let time = s.slice(0, 5);
    if (ampm === 'AM') {
        if (hours === 12) {
            // 12am edge-case
            return time.replace(s.slice(0, 2), '00');
        }
        return time;
    }
    else if (ampm === 'PM') {
        if (hours !== 12) {
            return time.replace(s.slice(0, 2), String(hours + 12));
        }
        return time; // 12pm edge-case
    }
    return s;
}
export const getTimeValue = (timeInMilliseconds, type) => {
    if (timeInMilliseconds <= 0 || isNaN(timeInMilliseconds)) {
        return 0;
    }
    const hour = Math.floor(timeInMilliseconds / 1000 / 60 / 60);
    if (type === 'hour') {
        return hour;
    }
    const minute = (timeInMilliseconds - hour * 60 * 60 * 1000) / 1000 / 60;
    return minute;
};
